/***
 * 通用使用Messagebox弹窗预览效果
 */
import EffectPreview from './EffectPreview.vue';

export default async function useEffectPreview(h, options = {}) {
  const myRef = `myRef${Math.floor(Math.random() * 10000) + 1}`;
  await Vue.prototype
    .$vhMsgbox({
      title: options.title || '提示', // 自定义标题,
      // closeOnClickModal: false,
      showCancelButton: false,
      showConfirmButton: false,
      customClass: 'custom-message-box',
      message: h(EffectPreview, {
        props: {
          itRef: myRef,
          scene: options.scene
        }
      })
    })
    .catch();
}
